import type {
  CreateSubscriptionRequest,
  NotificationEventType,
  NotificationTargetType,
  OrganisationShortType,
} from '@/types'

export const ORGANISATIONS_PAGE_SIZE = 15
export const USERS_PAGE_SIZE = 20
export const SEARCH_DEBOUNCE = 400
export const SCROLL_LOAD_OFFSET = 60

export type TargetType = 'SELF' | 'USER' | 'ROLE_GROUP' | 'CHAT_ID'
export type OrgScope = 'MY' | 'CLIENT'

export type OrganisationOption = {
  value: string
  label: string
  org: OrganisationShortType
}

export const TARGET_TYPE_OPTIONS: { value: TargetType; label: string }[] = [
  { value: 'SELF', label: 'Себе' },
  { value: 'USER', label: 'Другой пользователь' },
  { value: 'ROLE_GROUP', label: 'Группа ролей' },
  { value: 'CHAT_ID', label: 'ID Чата' },
]

export const ORG_SCOPE_OPTIONS: { value: OrgScope; label: string }[] = [
  { value: 'MY', label: 'Моя организация' },
  { value: 'CLIENT', label: 'Организация клиента' },
]

export const isScrolledToBottom = (element: HTMLElement) =>
  element.scrollHeight - element.scrollTop - element.clientHeight <
  SCROLL_LOAD_OFFSET

type SubscriptionTarget = {
  canManageGlobal: boolean
  targetType: TargetType
  currentUserId?: string
  selectedUserId?: string
  selectedRole: string | null
  chatId: string
}

export const getTargetId = ({
  canManageGlobal,
  targetType,
  currentUserId,
  selectedUserId,
  selectedRole,
  chatId,
}: SubscriptionTarget): string | null => {
  if (!canManageGlobal || targetType === 'SELF') return currentUserId ?? null
  if (targetType === 'USER') return selectedUserId ?? null
  if (targetType === 'ROLE_GROUP') return selectedRole
  return chatId.trim() || null
}

export const getRequestTargetType = (
  canManageGlobal: boolean,
  targetType: TargetType
): NotificationTargetType =>
  !canManageGlobal || targetType === 'SELF' ? 'USER' : targetType

type SubscriptionRequestParams = {
  eventType: NotificationEventType
  targetType: NotificationTargetType
  targetId: string
  withClientFilter: boolean
  allMyClients: boolean
  selectedClientIds: string[]
}

export const buildSubscriptionRequest = ({
  eventType,
  targetType,
  targetId,
  withClientFilter,
  allMyClients,
  selectedClientIds,
}: SubscriptionRequestParams): CreateSubscriptionRequest => ({
  eventType,
  targetType,
  targetId,
  filters: withClientFilter
    ? {
        allMyClients,
        clientIds: allMyClients ? [] : selectedClientIds,
      }
    : null,
})
